// IELTS Mock 8 — Academic Writing (grouped bar chart + advantages/disadvantages essay)
// Same shape as IELTS_DATA_WRITING in ../IeltsWriting.js. `mock` is forwarded to
// /api/scoring/writing-validate so it is checked against this mock's reference points.
const IELTS_MOCK8_WRITING = {
  title: "Academic Writing Practice Test 8",
  tasks: [
    {
      id: "task1",
      mock: 8,
      title: "Task 1: Report (20 min)",
      prompt:
        "The bar chart shows the percentage of electricity generated from six different sources in the country of Norland in 2000, 2010 and 2020. Summarise the information by selecting and reporting the main features, and make comparisons where relevant.",
      image: "/images/ielts-mock8/writing_task1_electricity.svg",
      minWords: 150,
      keywords: ["coal", "gas", "nuclear", "hydro", "wind", "solar", "electricity", "percent", "proportion", "2000", "2020", "increas", "declin", "compar"],
      diagramType: "bar"
    },
    {
      id: "task2",
      mock: 8,
      title: "Task 2: Essay (40 min)",
      prompt:
        "Increasingly, decisions such as which job applicants to interview, who should receive a bank loan and how much people pay for insurance are being made by computer algorithms rather than by people. Do the advantages of this development outweigh the disadvantages?",
      minWords: 250,
      keywords: ["algorithm", "computer", "decision", "automat", "bias", "fair", "efficien", "transparen", "human", "data", "advantage", "disadvantage", "outweigh"]
    }
  ]
};

export default IELTS_MOCK8_WRITING;
